import React, { Component } from 'react';

const SEASONS = {
  '1': { title: 'SUMMER', desc: 'ความงดงามของฤดูร้อน', hashtag: 'SUMMER' },
  '2': { title: 'WINTER', desc: 'หิมะในฤดูหนาว', hashtag: 'WINTER' },
  '3': { title: 'SPRING', desc: 'ใบไม้ผลิสวยงามอย่างไร', hashtag: 'SPRING' },
  '4': { title: 'AUTUMN', desc: 'ฤดูใบไม้ร่วง', hashtag: 'AUTUMN' }
};

export class ImgCard extends Component {
  render() {
    var s = SEASONS[this.props.id] || SEASONS['1'];
    var href = '/programs/search?hashtag=' + encodeURIComponent(s.hashtag);
    return (
      <a href={href} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
        <div className="article-card-3 row">
          <div className="article-card-IMG col-md-12">
            <img src={require('../img/img_art_' + this.props.id + '.png')} alt={s.title} />
            <div className="image-card-info">
              <div className="article-card-title">{s.title}</div>
              <div className="article-card-detail">{s.desc}</div>
              <div className="article-card-read">
                <a href={href}>Read more</a>
              </div>
            </div>
          </div>
        </div>
      </a>
    );
  }
}
